<template>
  <div v-if="loaded">
    <b-row>
      <b-col lg="12">
        <Mail
          ref="mail"
          :emails_list="mandat.emails"
          :attached_objects="object"
          :free_mail="false"
          :body="body"
          :subject="subject"
          @email_change="refresh"
          @close="$emit('close', $event)"
          @confirm="$emit('close', {confirm: true})"
        >
        </Mail>
      </b-col>
      <b-col lg="12" class="my-1">
        <b-row class="my-1 align-items-center">
          <div class="col-3">
            <label style="margin-bottom: 0px">Référence : </label>
          </div>
          <div class="col-9">
            <b-form-input type="text" v-model="object[0].ref"></b-form-input>
          </div>
        </b-row>
        <b-row class="my-1 align-items-center">
          <div class="col-3">
            <label style="margin-bottom: 0px">Adresse commerciale : </label>
          </div>
          <div class="col-9">
            <b-form-input type="text" v-model="object[0].adr"></b-form-input>
          </div>
        </b-row>
        <b-row class="my-1 align-items-center">
          <div class="col-3">
            <label style="margin-bottom: 0px"
              >Générer le document prérempli pour l'huissier
            </label>
          </div>
          <div class="col-9">
            <b-form-checkbox type="text" v-model="object[0].dp"></b-form-checkbox>
          </div>
        </b-row>
        <b-row class="mt-3">
          <b-col lg="12">
            <object
              style="width: 100%; height: 1000px"
              :data="MDPdfPath()"
              type="application/pdf"
            >
              <embed :src="MDPdfPath()" type="application/pdf" />
            </object>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import documents from "@/services/documents";
import Mail from "@/components/Mail.vue";
export default {
  name: "MDMail",
  components: {
    Mail,
  },
  props: {
    mandat_id: [Number, String],
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      
      mandat: {},
      huissierID: null,
      componentKey: 0,
      ref: "",
      adr: "",
      dp: false,
      body: "",
      signature: `Cabinet De Greft

Rue Chantraine 158/021
B-4420 SAINT-NICOLAS

TEL.: 0032 4 254 05 50
FAX: 0032 4 252 22 13
TVA : BE0478434880
IBAN: BE43 3630 4182 2501
BIC: BBRUBEBB`,
      loaded: false,
      subject: "",
      object: [
        {
          object: "MiseEnDemeure",
          id: this.mandat_id,
          huissierID: this.huissierID,
          ref: '',
          dp: false,
          adr: '',
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    refresh(payload) {
      this.huissierID = payload.id;
      this.object[0].huissierID = this.huissierID;
      this.load(true);
    },
    
    load(refresh = false) {
      documents
        .get_single(
          "mandat_MD",
          this.$props.mandat_id,
          "huissierID=" + this.huissierID
        )
        .then((response) => {
          this.mandat = response.data;
          this.body = this.mandat.body + "\n" + this.signature;
          this.subject = this.mandat.subject;
          this.loaded = true;
          if (refresh) {
            this.$refs.mail.refresh(this.body);
          }
        });
    },
    MDPdfPath() {
      let url =
        this.$store.getters.url + "/warrant/" + this.mandat_id + "/md/pdf?";
      url += "&huissierID=" + encodeURIComponent(this.huissierID);
      url += "&ref=" + encodeURIComponent(this.object[0].ref);
      url += "&adr=" + encodeURIComponent(this.object[0].adr);
      url += "&dp=" + encodeURIComponent(this.object[0].dp);
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>